import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

export { isValidPhoneNumber };

/**
 * Controlled E.164 value (e.g. +995577123456). onChange receives the full string or undefined when cleared.
 */
const StyledPhoneInput = ({ value, onChange, error, isDark, className = "" }) => {
  return (
    <>
      <div className={`phone-input-wrapper phone-input-${isDark ? "dark" : "light"} ${className}`}>
        <PhoneInput
          international
          defaultCountry="GE"
          value={value || undefined}
          onChange={onChange}
          placeholder="Phone number"
        />
        {error && (
          <small className={`text-footnote mt-1 block text-status-danger`}>
            {error}
          </small>
        )}
      </div>
      <style>{`
        .phone-input-wrapper .PhoneInput {
          display: flex;
          gap: 0;
          align-items: center;
          position: relative;
        }

        .phone-input-wrapper .PhoneInputCountry {
          position: absolute;
          left: 0.75rem;
          top: 50%;
          transform: translateY(-50%);
          display: flex;
          align-items: center;
          z-index: 2;
          pointer-events: none;
        }

        .phone-input-wrapper .PhoneInputCountryIcon {
          width: 1.5rem;
          height: 1.5rem;
          box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
          border-radius: 0.25rem;
          flex-shrink: 0;
        }

        .phone-input-wrapper .PhoneInputCountrySelect {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 3rem;
          z-index: 3;
          border: none;
          cursor: pointer;
          opacity: 0;
          pointer-events: auto;
        }

        .phone-input-wrapper .PhoneInputCountrySelectArrow {
          opacity: 0;
          display: none;
        }

        .phone-input-wrapper .PhoneInputInput {
          width: 100%;
          border-radius: 1rem;
          padding: 0.75rem 1rem 0.75rem 3.5rem;
          font-size: 1rem;
          outline: none;
          transition: all 0.2s;
          border: 2px solid;
          ${isDark
            ? "border-color: rgba(255, 255, 255, 0.1); background-color: rgba(255, 255, 255, 0.05); color: rgb(241, 245, 249);"
            : "border-color: rgb(226, 232, 240); background-color: white; color: rgb(15, 23, 42);"}
        }

        .phone-input-wrapper .PhoneInputInput:focus {
          ${isDark
            ? "border-color: rgba(76, 214, 178, 0.5); background-color: rgba(255, 255, 255, 0.1);"
            : "border-color: rgba(76, 214, 178, 0.5); background-color: rgb(248, 250, 252);"}
        }

        .phone-input-wrapper .PhoneInputInput::placeholder {
          color: rgb(148, 163, 184);
        }

        .phone-input-wrapper .PhoneInputCountryIcon--border {
          box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
        }
      `}</style>
    </>
  );
};

export default StyledPhoneInput;
